<div *ngIf="model.isRunning && model.showTimerAsClock" [class]="model.rootCss">
    <svg *ngIf="model.showProgress" [class]="model.getProgressCss()" [style.stroke-dasharray]="circleLength" [style.stroke-dashoffset]="progress" [size]="'auto'" [iconName]="'icon-timercircle'" sv-ng-svg-icon></svg>
    <div [class]="model.textContainerCss">
        <span [class]="model.majorTextCss">{{ model.clockMajorText }}</span>
        <span *ngIf="model.clockMinorText" [class]="model.minorTextCss">{{ model.clockMinorText }}</span>
    </div>
</div>
<div *ngIf="model.isRunning && !model.showTimerAsClock" [class]='model.survey.getCss().timerRoot'>{{model.text}}</div>